export default "__VITE_ASSET__33126c14__"